(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-articles-blocks"] && !window.DesignMode) return;
  try {
    
(() => {
  const DESIRED_SMALL = 6;
  const MAX_PAGES_SCAN = 20;
  const DEBUG = true;

  const log  = (...a) => DEBUG && console.log("[CAW]", ...a);
  const warn = (...a) => DEBUG && console.warn("[CAW]", ...a);
  const err  = (...a) => DEBUG && console.error("[CAW]", ...a);

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".caw").forEach(initCaw);
  });

  function initCaw(caw) {
    if (caw.dataset.cawEnhanced === "1") return;
    caw.dataset.cawEnhanced = "1";

    const blog = (caw.dataset.blogHandle || "").trim();
    const tag  = (caw.dataset.tagHandle  || "").trim();
    if (!blog || !tag) { warn("manca blog/tag handle", { blog, tag }); return; }

    const listEl = caw.querySelector(".caw__list");
    const grid   = caw.querySelector(".caw__grid");
    if (!listEl || !grid) { warn("manca grid/list"); return; }

    let needFeatured = !caw.querySelector(".caw__featured");
    let haveSmall    = caw.querySelectorAll(".caw__item").length;

    const used = new Set();
    caw.querySelectorAll(".caw__featured a, .caw__item a").forEach(a => {
      try { used.add(new URL(a.getAttribute("href"), location.origin).pathname); } catch {}
    });

    const start = () => hydrate({ blog, tag, used, needFeatured, haveSmall, caw, listEl, grid }).catch(err);
    observeOnce(caw, start);
    setTimeout(start, 600);

    // Guard global: ogni mutazione dentro .caw → rinforza immagini
    guardCaw(caw);
  }

  async function hydrate({ blog, tag, used, needFeatured, haveSmall, caw, listEl, grid }) {
    if (listEl.getAttribute("data-caw-loaded") === "1") return;
    listEl.setAttribute("data-caw-loaded","1");

    for (let page = 1; page <= MAX_PAGES_SCAN; page++) {
      if (!needFeatured && haveSmall >= DESIRED_SMALL) break;

      const endpoint = `/blogs/${encodeURIComponent(blog)}/tagged/${encodeURIComponent(tag)}?view=caw-json&page=${page}`;
      const data = await fetchJSON(endpoint);
      if (!data || !Array.isArray(data.articles) || data.articles.length === 0) break;

      for (const art of data.articles) {
        if (!art || !art.url) continue;
        const path = safePath(art.url);
        if (!path || used.has(path)) continue;

        if (needFeatured) {
          renderFeatured(grid, art);
          needFeatured = false;
          used.add(path);
          continue;
        }
        if (haveSmall < DESIRED_SMALL) {
          renderSmall(listEl, art);
          haveSmall++;
          used.add(path);
        }
        if (!needFeatured && haveSmall >= DESIRED_SMALL) break;
      }

      if (typeof data.pages === "number" && page >= data.pages) break;
    }
  }

  /* =================== IMAGE NORMALIZER + LOCK =================== */

  // Rimuove QUALSIASI suffisso Shopify: _480x, _960x960, _grande, _master, _original, _crop_..., _progressive, @2x
  function toOriginalShopify(url){
    if (!url) return "";
    try{
      const u = new URL(url, location.origin);
      // estensione supportata
      const ext = "(?:jpe?g|png|gif|webp|avif)";
      // rimuovi size/named-size prima dell'estensione
      u.pathname = u.pathname
        // es. _2048x2048, _480x
        .replace(/_(?:\d{1,4}x\d{1,4}|\d{1,4}x)(?=\.(?:jpe?g|png|gif|webp|avif)$)/i, "")
        // es. _pico,_icon,_thumb,_small,_compact,_medium,_large,_grande,_master,_original
        .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|original)(?=\.(?:jpe?g|png|gif|webp|avif)$)/i, "")
        // es. _crop_center, _crop_top, ecc.
        .replace(/_crop_[^.]+(?=\.(?:jpe?g|png|gif|webp|avif)$)/i, "")
        // es. @2x prima dell'estensione
        .replace(/@2x(?=\.(?:jpe?g|png|gif|webp|avif)$)/i, "")
        // es. _progressive
        .replace(/_progressive(?=\.(?:jpe?g|png|gif|webp|avif)$)/i, "");
      // rimuovi ?width=..., ?height=...
      u.searchParams.delete("width");
      u.searchParams.delete("height");
      return u.toString();
    }catch{ return url; }
  }

  function enforceOriginal(img, candidateUrl, ctx){
    const original = toOriginalShopify(candidateUrl);
    // rimuovi responsive (altrimenti il browser sceglie la ridotta)
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    // forza caricamento eager per ridurre race condition con lazyloader di tema
    img.loading  = "eager";
    img.decoding = "async";
    img.src = original;
    img.dataset.cawOriginal = original;
    img.dataset.cawLocked   = "1";

    log("enforce", ctx, { candidate: candidateUrl, original });

    img.addEventListener("load",  () => log("IMG ✓", ctx, img.currentSrc || img.src));
    img.addEventListener("error", () => err("IMG ✗", ctx, img.currentSrc || img.src));

    // osserva lo specifico <img>
    const mo = new MutationObserver(() => {
      // se qualcuno ha rimesso size suffix o ha reintrodotto srcset → reset
      const current = img.getAttribute("src") || "";
      const pathname = safePath(current) || current;
      const hasSizeSuffix = /_(?:\d{1,4}x\d{1,4}|\d{1,4}x|pico|icon|thumb|small|compact|medium|large|grande|master|original|progressive|crop_[^.]+)(?=\.(?:jpe?g|png|gif|webp|avif)(?:$|\?))/i.test(pathname);
      if (hasSizeSuffix || img.hasAttribute("srcset")) {
        img.removeAttribute("srcset");
        img.removeAttribute("sizes");
        img.src = img.dataset.cawOriginal;
        warn("restore original", ctx, img.dataset.cawOriginal);
      }
    });
    mo.observe(img, { attributes: true, attributeFilter: ["src","srcset","sizes"] });
  }

  // Guardia globale dentro .caw: childList+attributes, intercetta <img> nuovi o modificati
  function guardCaw(root){
    const reImg = /\.cdn\.shop\/|\/cdn\/shop\//i; // euristica: immagini Shopify/CDN
    const fixImg = (img) => {
      if (!img || img.dataset.cawLocked === "1") return;
      const raw = img.getAttribute("src") || img.getAttribute("data-src") || "";
      if (!raw) return;
      if (!reImg.test(raw)) return; // lascia stare immagini esterne non Shopify
      enforceOriginal(img, raw, "[guard]");
    };

    // inizializza su immagini già presenti (se qualcuna è stata messa dal tema)
    root.querySelectorAll("img.caw__img").forEach(fixImg);

    const mo = new MutationObserver((mutList) => {
      for (const m of mutList) {
        if (m.type === "childList") {
          m.addedNodes.forEach(n => {
            if (n.nodeType !== 1) return;
            if (n.matches?.("img.caw__img")) fixImg(n);
            n.querySelectorAll?.("img.caw__img").forEach(fixImg);
          });
        } else if (m.type === "attributes" && m.target.matches?.("img.caw__img")) {
          fixImg(m.target);
        }
      }
    });
    mo.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ["src","srcset","sizes"] });

    // doppia rete di sicurezza per i primi 3s
    const t0 = performance.now();
    const tick = () => {
      root.querySelectorAll("img.caw__img").forEach(img => {
        if (img.dataset.cawLocked === "1") return;
        const s = img.getAttribute("src") || "";
        if (s) enforceOriginal(img, s, "[tick]");
      });
      if (performance.now() - t0 < 3000) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* =================== RENDER =================== */

  function renderFeatured(grid, art) {
    if (grid.querySelector(".caw__featured")) return;
    const card = document.createElement("article");
    card.className = "caw__featured"; card.setAttribute("role","article");

    const fig = document.createElement("figure"); fig.className = "caw__figure";
    const a = document.createElement("a");
    a.className = "caw__img-link"; a.href = art.url; a.setAttribute("rel","noopener");
    a.setAttribute("aria-label", art.title || "");

    const img = document.createElement("img");
    img.className = "caw__img caw__img--featured";
    img.width = 800; img.height = 450; img.alt = (art?.image?.alt || art.title || "");
    // candidata: prendi l'URL più grande se c'è, altrimenti qualunque
    const candidate = chooseCandidate(art, true);
    enforceOriginal(img, candidate, "[featured] " + (art.title || art.url));

    a.appendChild(img); fig.appendChild(a);
    const cap = document.createElement("figcaption"); cap.className = "visually-hidden"; cap.textContent = art.title || "";
    fig.appendChild(cap);

    const content = document.createElement("div");
    content.className = "caw__content";
    content.innerHTML = `
      <h3 class="caw__headline"><a href="${escAttr(art.url)}" rel="noopener">${esc(art.title || "")}</a></h3>
      <p class="caw__meta">
        ${art.author ? `<span class="caw__by">By ${esc(art.author)}</span><span class="caw__sep">·</span>` : ""}
        ${art.published_at_readable ? esc(art.published_at_readable) : ""}
      </p>`;

    card.appendChild(fig); card.appendChild(content);
    grid.insertAdjacentElement("afterbegin", card);
  }

  function renderSmall(listEl, art) {
    const card = document.createElement("article");
    card.className = "caw__item"; card.setAttribute("role","listitem");
    card.setAttribute("aria-label", art.title || "");

    const a = document.createElement("a");
    a.className = "caw__thumb-link"; a.href = art.url; a.setAttribute("rel","noopener");
    a.setAttribute("aria-label", art.title || "");

    const img = document.createElement("img");
    img.className = "caw__img caw__img--small";
    img.width = 300; img.height = 200; img.alt = (art?.image?.alt || art.title || "");

    const candidate = chooseCandidate(art, false);
    enforceOriginal(img, candidate, "[small] " + (art.title || art.url));

    a.appendChild(img);

    const content = document.createElement("div");
    content.className = "caw__item-content";
    content.innerHTML = `
      <h4 class="caw__item-title"><a href="${escAttr(art.url)}" rel="noopener">${esc(art.title || "")}</a></h4>
      ${art.author ? `<p class="caw__meta"><span class="caw__by">By ${esc(art.author)}</span></p>` : ""}`;

    card.appendChild(a); card.appendChild(content);
    listEl.insertAdjacentElement("beforeend", card);
  }

  /* =================== JSON + UTIL =================== */

  async function fetchJSON(url) {
    const ctrl = new AbortController(); const to = setTimeout(() => ctrl.abort(), 15000);
    try {
      const r = await fetch(url, { credentials: "same-origin", signal: ctrl.signal, headers: { "Accept": "application/json" } });
      if (!r.ok) return null;
      const t = await r.text();
      return JSON.parse(t);
    } catch (e) { err("fetchJSON", e); return null; }
    finally { clearTimeout(to); }
  }

  function chooseCandidate(art, featured){
    const im = art && art.image ? art.image : {};
    const listFeatured = [im.src_1600, im.src_1200, im.src_960, im.src_800, im.src_600, im.src_480, im.src_300, art?.og_image];
    const listSmall    = [im.src_960,  im.src_800,  im.src_600, im.src_480, im.src_300, art?.og_image];
    const list = featured ? listFeatured : listSmall;
    for (const u of list) if (u) return u;
    const inContent = firstImgFromHtml(art?.content_html);
    return inContent || "";
  }

  function firstImgFromHtml(html){
    if (!html) return "";
    const div = document.createElement("div"); div.innerHTML = html;
    const img = div.querySelector("img"); if (!img) return "";
    const src = img.getAttribute("data-src") || img.getAttribute("data-original") || img.getAttribute("src");
    return toAbs(src || "");
  }

  function safePath(href){ try { return new URL(href, location.origin).pathname; } catch { return href || ""; } }
  function toAbs(u){
    if(!u) return "";
    if (u.startsWith("//")) return location.protocol + u;
    if (u.startsWith("/"))  return location.origin + u;
    if (u.startsWith("http://")) return u.replace(/^http:\/\//i, "https://");
    return u;
  }

  function observeOnce(el, cb) {
    if (!("IntersectionObserver" in window)) { cb(); return; }
    const io = new IntersectionObserver(es => {
      if (es.some(e => e.isIntersecting)) { io.disconnect(); cb(); }
    }, { rootMargin: "200px 0px" });
    io.observe(el);
  }

  function esc(s){ return String(s||"").replace(/[&<>"']/g, m => ({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[m])); }
  function escAttr(s){ return esc(s).replace(/"/g,"&quot;"); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
